<template>
  <form-wrapper @submit="onSubmit">
    <div slot="box" v-loading="loading">
      <el-form-item label="Tytuł" :error="errors['title']" required>
        <el-input v-model="form['title']" />
      </el-form-item>
      <el-form-item
        label="Tekst alternatywny (dla czytników)"
        :error="errors['alt']"
      >
        <el-input v-model="form['alt']" />
      </el-form-item>

      <!-- Video Status and Error Messages -->
      <div
        v-if="
          form.id &&
            (form.is_processing ||
              form.processing_error ||
              form.processing_completed)
        "
      >
        <h3>Status przetwarzania wideo</h3>

        <!-- Processing Status -->
        <el-alert
          v-if="form.is_processing"
          title="W trakcie przetwarzania..."
          type="info"
          :closable="false"
          show-icon
        >
          <p>
            Wideo jest w trakcie przetwarzania. To może potrwać kilka minut.
          </p>
        </el-alert>

        <!-- Processing Error -->
        <el-alert
          v-if="form.processing_error"
          :title="'Błąd przetwarzania: ' + form.processing_error"
          type="error"
          :closable="false"
          show-icon
        >
          <template slot="title">
            Błąd przetwarzania wideo
            <el-button
              v-if="form.processing_error"
              @click="regenerateVideo"
              type="primary"
              size="small"
              style="margin-left: 10px;"
              :loading="regenerating"
            >
              Spróbuj ponownie
            </el-button>
          </template>
          <p>{{ form.processing_error }}</p>
        </el-alert>

        <!-- Processing Completed -->
        <el-alert
          v-if="
            form.processing_completed &&
              !form.is_processing &&
              !form.processing_error
          "
          title="Przetwarzanie zakończone"
          type="success"
          :closable="false"
          show-icon
        >
          <p>Wideo zostało pomyślnie przetworzone.</p>
        </el-alert>
      </div>

      <div>
        <h2>Wideo</h2>
        <video
          v-if="form.file_url"
          :src="form.file_url"
          controls
          preload="metadata"
          style="max-width: 100%; margin-bottom: 20px;"
        />
        <p>Aby zmienić wideo</p>
        <upload-tab @submit="changeVideo" />
      </div>
    </div>
    <form-sidebar
      :loading="loading"
      slot="sidebar"
      @submit="onSubmit"
      :inModal="inModal"
      :redirectRoute="redirectRoute"
    />
  </form-wrapper>
</template>
<script>
import { Video } from '@/api'
import FormMixin from '@/crudBases/form/FormMixin'
import UploadTab from '@/components/inputs/VideoDialog/UploadTab'

export default {
  mixins: [FormMixin],
  components: {
    UploadTab
  },
  data() {
    return {
      redirectRoute: { name: 'Video List' },
      regenerating: false,
      statusInterval: null
    }
  },
  methods: {
    changeVideo(video) {
      if (!video) return
      this.$set(this.form, 'file', video)
      this.updateVideoPreview()
    },
    updateVideoPreview() {
      const value = this.form.file
      const fileType = typeof value
      if (fileType === 'object') {
        const reader = new FileReader()
        reader.onload = e => {
          this.$set(this.form, 'file_url', e.target.result)
        }
        reader.readAsDataURL(this.form.file)
      }
    },
    async regenerateVideo() {
      if (!this.form.id) return

      this.regenerating = true
      try {
        await this.service.reprocess({ id: this.form.id })
        this.$message.success(
          'Przetwarzanie wideo zostało ponownie uruchomione'
        )

        // Refresh the form data to get updated status
        await this.fetchData()

        // Start monitoring status if processing
        this.startStatusMonitoring()
      } catch (error) {
        this.$message.error(
          'Błąd podczas ponownego uruchamiania przetwarzania: ' + error.message
        )
      } finally {
        this.regenerating = false
      }
    },
    async checkVideoStatus() {
      if (!this.form.id) return

      try {
        const response = await this.service.status({ id: this.form.id })
        const status = response.data

        // Update form with status data
        this.$set(this.form, 'is_processing', status.is_processing)
        this.$set(
          this.form,
          'processing_completed',
          status.processing_completed
        )
        this.$set(this.form, 'processing_error', status.processing_error)

        // Stop monitoring if processing is complete or failed
        if (!status.is_processing) {
          this.stopStatusMonitoring()
        }
      } catch (error) {
        console.error('Error checking video status:', error)
      }
    },
    startStatusMonitoring() {
      if (this.statusInterval) {
        clearInterval(this.statusInterval)
      }

      // Check status every 5 seconds
      this.statusInterval = setInterval(() => {
        this.checkVideoStatus()
      }, 5000)
    },
    stopStatusMonitoring() {
      if (this.statusInterval) {
        clearInterval(this.statusInterval)
        this.statusInterval = null
      }
    }
  },
  computed: {
    service() {
      return Video
    }
  },
  mounted() {
    // Start monitoring if video is being processed
    if (this.form.id && this.form.is_processing) {
      this.startStatusMonitoring()
    }
  },
  beforeDestroy() {
    // Clean up interval when component is destroyed
    this.stopStatusMonitoring()
  }
}
</script>
